(() => {
  if (window.PoleCartUpsellsInitialized) return;

  window.PoleCartUpsellsInitialized = true;

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-pole-upsell-add]");

    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = "ADDING...";

    try {
      let sections = [];

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", {
          bubbles: true,
          detail: {
            sections: sections
          }
        })
      );

      const response = await fetch(
        window.MinimogSettings.routes.cart_add_url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ],
            sections: sections,
            sections_url: window.location.pathname
          })
        }
      );

      const addedState = await response.json();

      if (!response.ok || addedState.status) {
        throw new Error(
          addedState.description ||
          addedState.message ||
          "Unable to add product"
        );
      }

      const cartResponse = await fetch(
        window.MinimogSettings.routes.cart,
        {
          headers: {
            "Accept": "application/json"
          }
        }
      );

      const cart = await cartResponse.json();

      cart.sections = addedState.sections;

      window.MinimogEvents.emit(
        MinimogTheme.pubSubEvents.cartUpdate,
        {
          cart: cart
        }
      );

    } catch (error) {
      console.error("POLE cart upsell error:", error);

      button.disabled = false;
      button.textContent = originalText;
    }
  });
})();